import {Component, OnInit} from '@angular/core';
import {ArticleService} from "../../../../service/article.service";
import {ArticleVM} from "../../../../model/viewModel/article.vm";

@Component({
  selector: 'app-main-article',
  templateUrl: './main-article.component.html',
  styleUrls: ['./main-article.component.scss']
})
export class MainArticleComponent implements OnInit {
  articles: ArticleVM[] | null = null;

  constructor(private articleService: ArticleService) {
  }

  ngOnInit(): void {
    this.articleService.getMainArticles().subscribe(articles => {
      this.articles = articles;
    });
  }

}
